import { useEffect, useState } from "react";
import { Upload, type UploadProps, type UploadUserFile } from "zhihao-ui-react";
import type { File as FileEntity } from "@zhihaoscm/entity";
import { uploadFile, type UploadApi, validateUploadFile } from "./uploadAdapter";

export interface ImgsProps {
    fileList?: UploadUserFile[];
    imageUrl?: string;
    imageId?: number;
    api?: UploadApi;
    disabled?: boolean;
    limit?: number;
    fileSize?: number;
    fileType?: string[];
    onUpdateFileList?: (value: UploadUserFile[]) => void;
    onUpdateImageUrl?: (value: string) => void;
    onUpdateData?: (value: FileEntity) => void;
}

/** 多图上传，使用 zhihao-ui-react Upload 的 picture-card 模式。 */
export default function Imgs({
    fileList = [],
    imageUrl = "",
    imageId: _imageId,
    api,
    disabled = false,
    limit = 5,
    fileSize = 5,
    fileType = ["image/jpeg", "image/png", "image/gif"],
    onUpdateFileList,
    onUpdateImageUrl,
    onUpdateData
}: ImgsProps) {
    const [files, setFiles] = useState<UploadUserFile[]>(fileList);
    const [previewUrl, setPreviewUrl] = useState(imageUrl);
    useEffect(() => setFiles(fileList), [fileList]);
    const beforeUpload: UploadProps["beforeUpload"] = file => validateUploadFile(file, fileType, fileSize, "图片");
    const httpRequest: UploadProps["httpRequest"] = async options => {
        const data = await uploadFile(options, api);
        const url = data.path || "";
        const nextFiles = [...files, { name: data.name || options.file.name, url, response: data }];
        setFiles(nextFiles);
        setPreviewUrl(url);
        onUpdateFileList?.(nextFiles);
        onUpdateImageUrl?.(url);
        onUpdateData?.(data);
        options.onSuccess(data);
    };
    const remove = (file: UploadUserFile) => {
        const nextFiles = files.filter(item => item.uid !== file.uid && item.url !== file.url);
        setFiles(nextFiles);
        onUpdateFileList?.(nextFiles);
        if (file.url === previewUrl) {
            const nextUrl = nextFiles[0]?.url || "";
            setPreviewUrl(nextUrl);
            onUpdateImageUrl?.(nextUrl);
        }
    };
    return (
        <Upload
            action="#"
            listType="picture-card"
            accept={fileType.join(",")}
            disabled={disabled}
            limit={limit}
            fileList={files}
            beforeUpload={beforeUpload}
            httpRequest={httpRequest}
            onRemove={remove}
            showFileList
        >
            <span>上传图片</span>
        </Upload>
    );
}
